import { fourierConfig } from "../fourier/config";
import { HookScene, SceneDefs } from "./HookScene";
import { HookPatterns } from "./HookPatterns";
import { HOOK_FRAMES, type HookPattern } from "./hookTiming";

/** One SVG source used by both Remotion/Chromium and the headless SVG fallback. */
export const HookFrame = ({
  pattern,
  frame,
}: {
  pattern: HookPattern;
  frame: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1080 1920"
    width={720}
    height={1280}
    style={{ overflow: "hidden" }}
  >
    <SceneDefs />
    <defs>
      <radialGradient id="ambient" cx="46%" cy="51%" r="62%">
        <stop offset="0%" stopColor="#183A4D" stopOpacity={0.2} />
        <stop offset="100%" stopColor="#183A4D" stopOpacity={0} />
      </radialGradient>
    </defs>
    <rect width={1080} height={1920} fill={fourierConfig.colors.background} />
    <rect width={1080} height={1920} fill="url(#ambient)" />
    {frame >= HOOK_FRAMES ? (
      <HookScene frame={frame} />
    ) : (
      <HookPatterns pattern={pattern} frame={frame} />
    )}
  </svg>
);
